// extracted by mini-css-extract-plugin
export default {"modalOverlay":"fF-z","modalContent":"gF-z","header":"hF-z","close":"iF-z"};